import "./tablestyle.scss";
import {
  Grid,
  GridCellProps,
  GridColumn as Column,
  GridItemChangeEvent,
  GridPageChangeEvent,
  GridPagerSettings,
  GridRowProps,
  GridNoRecords
} from "@progress/kendo-react-grid";
import { DropDown } from "./myDropDown";
import ButtonDefault from "../button";
import { useEffect, useState } from "react";
import AddProject from "../../modal/addProject";
import { useNavigate } from "react-router-dom";
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { checkAvailability, checkPositionStatus, checkPriority, checkWorkLocation, getMilliSecUTC } from "../../utils/EllowUtils";
import * as CONSTANTS from '../../utils/CONSTANTS'
import { contractMetadata, getAllocatedto, getProjects, updatePositionAPI, getAllRecruiters, updatePositionStatus, updateProject ,  getProjectDetails, saveFulltimejobDetails} from "./services";
import ContractDetails from "../../modal/contractDetails";
import FulltimeDetails from "../../modal/fullTimeDetails";
import { getPositionsDetails } from "./services";
import mixpanelData, { userProfile } from "../../utils/mixpanel";
import { SortDescriptor } from "@progress/kendo-data-query";
import { orderBy } from "@progress/kendo-react-data-tools";
import NotificationAlert from "../notification";
import { Icon } from '@iconify/react';
import { getAPI } from "../../api/api";
import { REACT_APP_COMMON } from "../../utils/common";


const { v4: uuidv4 } = require("uuid");

const userLoginId = localStorage.getItem('loginId')

const AppliedResourcesTable = (props: any) => {
  let jobId = props.jobId
  const navigate = useNavigate()
  let customerId = props.customerId
  const { v4: uuidv4 } = require("uuid")
  const [projectList, setProjectList] = useState<any>()
  const [allocatedTo, setAllocatedTo] = useState<any>();
  const [contractLoginId, setContractLoginId] = useState<any>('')
  const [jobDetails, setJobDeatils] = useState<any>({})
  const [contractDetails, setContractDetails] = useState<any>(false);
  const [fulltimeDetails, setFulltimeDetails] = useState<any>(false);
  const [contractDefaultData, setContractDefaultData] = useState<any>()
  const [candidateEmail, setCandidateEmail] = useState<any>()
  const [contract, setContract] = useState<boolean>(false)
  const [ellowRate, setEllowRate] = useState<any>()
  const [currencyType, setCurrencyType] = useState<any>()
  const [billingType, setBillingType] = useState<any>()
  const [projectData, setProjectData] = useState<any>()
  const [position_Status, setPosition_Status] = useState<any>()
  const [contractEndDate, setContractEndDate] = useState<any>()
  const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [type, setType] = useState<string>('success')
  const [icon, setIcon] = useState<boolean>(false)
  const [hideBtn, setHideBtn] = useState<boolean>(false)

  const [terminateComment , setTerminateComment] = useState<any>()
  const [allocatedToId, setAllocatedToId] = useState<any>()
  const [allRecruiters, setAllRecruiters] = useState<any>()
  const [createdBy, setCreatedBy] = useState<any>()

  const initialSort: Array<SortDescriptor> = [
    { field: "name", dir: "asc" },
  ];

  const [sort, setSort] = useState(initialSort);
  const [skillList, setSkillList] = useState<any>()

  useEffect(() => {

    allocatedToList()
    if (customerId) {
      getProjectList(customerId)     
    }
    setJobDeatils(props.jobMetadata)
    setAllocatedToId(props.allocatedToId)
    RecruiterList()

    getAPI(REACT_APP_COMMON + '/skills').then((resp: any) => {
      if (resp && resp.status === 1) {
        setSkillList(resp.data);
      }
    })
   
  }, [])

  const getProjectList = (customerId: any) => {
    getProjects(customerId).then((response) => {
      if (response && response.status === 1) {
        setProjectList(response.data)
      }
    })
  }

  const allocatedToList = () => {
    getAllocatedto().then((response) => {
      if (response && response.status === 1) {
        setAllocatedTo(
          response.data.map((item: any) => {
            return item.name;
          })
        )
      }
    })
  }

  const RecruiterList = () => {
    getAllRecruiters().then((response: any) => {
      if (response && response.status === 1) {
        setAllRecruiters(
          response.data.map((item: any) => {
            return item.name;
          })
        )
      }
    })
  }

  // const jobMetadata = (jobMetadata: any) => {
    
  //   if (jobMetadata) {
  //     const duration = parseInt(jobMetadata && jobMetadata.contractDuration && jobMetadata.contractDuration.split(' ')[0])
  //     let endDate = jobMetadata && jobMetadata.contractStartDate && new Date(jobMetadata.contractStartDate)
  //     endDate.setMonth(endDate.getMonth() + duration)
  //     setContractEndDate(getMilliSecUTC(endDate))
  //   }
  // }

  const skillsCell = (props: GridCellProps) => {

    let length = props.dataItem.skills && props.dataItem.skills.length;

    return (
      <td >
        <div className="skillsWrap">
          {props.dataItem.skills && props.dataItem.skills.map((item: string, key: number) => {
            return ((item) + (key < length - 1 ? ' , ' : ''))
          })}
        </div>
      </td>
    )
  }

  const rowClick = (e: any) => {
    props.rowClick(e)
  }

  const dateCell = (props: GridCellProps) => {
    let dateNumber = parseInt(props.dataItem.dateOfRegistration);
    let date = new Date(dateNumber).toDateString();

    return <td><div className="dateWrap">{date}</div></td>;
  }

  const experienceCell = (props: GridCellProps) => {
    return <td>{props.dataItem.experience + " Years"}</td>;
  }

  const ellowrateCell = (props: GridCellProps) => {
    return <td>{props.dataItem.positionEllowRate + " " + props.dataItem.positionCurrencyType + " / " + props.dataItem.positionBillingType}</td>;
  }

  const resourcecostCell = (props: GridCellProps) => {
    return (
      <td>
        {props.dataItem.positionStatus === "Resource Accepted Offer" && props.dataItem.availability !== 6 ?
          props && props.dataItem && props.dataItem.contractMetadata && props.dataItem.contractMetadata.contractRate && props.dataItem.contractMetadata.contractRate !== null ? `${props && props.dataItem && props.dataItem.contractMetadata && props.dataItem.contractMetadata.contractRate && props.dataItem.contractMetadata.contractRate}  ${props.dataItem.contractMetadata.currencyType} / ${props.dataItem.contractMetadata.billingType}` : 'Not Mentioned'
          :
          props.dataItem.rates !== null ? props.dataItem.rates + " " + props.dataItem.positionCurrencyType + " / " + props.dataItem.positionBillingType : 'Not Mentioned'
        }
      </td>
    )
  }

  const viewButton = (Props: GridCellProps) => { 
    
    return (
      <td>
        {Props.dataItem.positionStatus === "Resource Accepted Offer" && jobDetails.jobType !== 'Full time' && <button type="button" className="applyButton" onClick={(e: any) => { setContractLoginId(Props.dataItem.loginId); setContractDetails(true); setContractDefaultData(Props.dataItem.contractMetadata); setCandidateEmail(Props.dataItem.candidateEmail); setProjectData(Props.dataItem.projectDetails); setPosition_Status(Props.dataItem.positionStatus); setTerminateComment(Props.dataItem.terminateComment)}}>
          Contract Details</button>}
      </td>
    )
  }
  const signInDateCell = (props: GridCellProps) => {
    let signindate = props.dataItem.contractMetadata && props.dataItem.contractMetadata.signInDate ? new Date(props.dataItem.contractMetadata.signInDate).toDateString().slice(3) : "";
    return <td>{signindate}</td>;
  }
  const availablityCell = (props: GridCellProps) => {
    return (
      <td>
        {checkAvailability(props.dataItem.availabilityValue)}
      </td>
    )
  }

  const updatePositionStatusFunction = (value: any) => {
        
    updatePositionStatus(value).then((response) => {
      if (response.status === 1) {
        mixpanelData('TG-Position Status Change', {
          'source': 'Candidate position status changed by recruiter',
          'New Positions Status': checkPositionStatus(value.positionStatus),
          'distinct_id': localStorage.getItem('Email'),
        })
        mixpanelData('New TG - Position Status Change', {
          'source': 'Candidate position status changed by recruiter',
          'New Positions Status': checkPositionStatus(value.positionStatus),
          'distinct_id': localStorage.getItem('Email'),
          'Candidate email':response.data[0].candidateEmail,
          'Candidate name':response.data[0].candidateName,
          'Candidate id':response.data[0].candidate_id,
          'Company name':response.data[0].companyName,
          'Position name':response.data[0].jobTitle,
          'Job type': props.jobMetadata && props.jobMetadata.jobType,
          'Job id': value.jobId
        })
        if((parseInt(jobDetails.resourceCount)) - (jobDetails.closedCount + jobDetails.lossCount + 1) === 0){
          let closeData: any = {
            action: "close",
            jobId: value.jobId,
            loginIn: value.loginId,
            submittedBy: "RECRUITER",
            userLoginId: value.loginId,
          }
          updatePositionAPI(closeData).then((resp: any) => {
            if(resp.status === 1){
              getTableValues()
              getPositionsDetails(jobId)
            }
          })
        }
        else {
          getTableValues()
        }
      }
    })
  }

  // const getProjectWithcustomerId = () => {
  //   getProjects(customerId).then((response: any) => {
  //     if (response && response.status === '1') {
  //       setProjectData(response.data)
  //     }
  //   })
  // }

  const submitContractDetails = (data: any) => {
    
    let body = {

      "action": "update",
      "projectId": projectData !== undefined ? projectData.projectId : data.projectName.projectId,
      "projectName": data.projectName.projectName,
      "customerId": customerId,
      "reportingManagerName": data.reportingManagerName,
      "reportingManagerEmail": data.reportingManagerEmail,
      "userLoginId": userLoginId

    }

    let contractValues = {
      "userLoginId": localStorage.getItem("loginId"),
      "jobId": jobId,
      "candidateId": contractLoginId,
      "projectId": body.projectId,
      "contractMetadata": {
        "candidateCompanyEmail": data.candidateCompanyEmail !== "" ? data.candidateCompanyEmail : candidateEmail,
        "contractId": uuidv4(),
        "contractStartDate": data.contractStartDate,
        "contractEndDate": data.contractEndDate,
        "duration": data.duration,
        "contractRate": parseInt(data.contractRate),
        "currencyType": data.currencyType,
        "billingType": data.billingType,
        "closedBy": data.closedBy,
        "ellowRate": parseInt(data.ellowRate),
        "ellowBillingType": data.ellowBillingType,
        "ellowCurrencyType": data.ellowCurrencyType,
        "supportingDoc": data.supportingDocument,
        "skills": data.skills,
        "signInDate": data.signInDate,
        "inContract": true,
        "createdOn": getMilliSecUTC(new Date()),
        "updatedOn": getMilliSecUTC(new Date()),
      }
    }

    if (position_Status !== "Resource Accepted Offer") {
      updateProject(body).then((response) => {
        if (response && response.status === 1) {
          contractMetadata(contractValues).then((response) => {
            if (response && response.status === 1) {

              mixpanelData('TG-Contract Details Submitted', {
                'source': 'Recruiter submit contract details',
                "jobId": jobId,
                "candidateId": contractLoginId,
                "contractId": contractDefaultData && contractDefaultData.contractId ? contractDefaultData.contractId : uuidv4(),
                "contractStartDate": new Date(data && data.contractStartDate).toDateString(),
                "contractEndDate": new Date(data && data.contractEndDate).toDateString(),
                "duration": data.duration,
                "contractRate": parseInt(data.contractRate),
                "currencyType": data.currencyType,
                "billingType": data.billingType,
                "closedBy": data.closedBy,
                "ellowRate": parseInt(data.ellowRate),
                "ellowBillingType": data.ellowBillingType,
                "ellowCurrencyType": data.ellowCurrencyType,
                "supportingDoc": data.supportingDocument,
                "skills": data.skills,
                "signInDate": new Date(data.signInDate).toDateString(),
                "reportingManagerName": data.reportingManagerName,
                "reportingManagerEmail": data.reportingManagerEmail,
                "projectName": data.projectName,
                'distinct_id': localStorage.getItem('Email'),
                "candidate Email": candidateEmail,
                "candidateCompanyEmail": data.candidateCompanyEmail !== "" ? data.candidateCompanyEmail : candidateEmail,

              })
              mixpanelData('New TG - Contract Details Submitted', {
                'source': 'Recruiter submit contract details',
                "jobId": jobId,
                "Candidate loginid": contractLoginId,
                "Contract id": contractDefaultData && contractDefaultData.contractId ? contractDefaultData.contractId : uuidv4(),
                "contract StartDate": data && data.contractStartDate ? new Date(data && data.contractStartDate).toDateString() : 'NA',
                "contract EndDate": data && data.contractEndDate ? new Date(data && data.contractEndDate).toDateString() : 'NA',
                "Duration": data.duration,
                "Resource cost": `${parseInt(data.contractRate)} ${data.currencyType} / ${data.billingType}`,
                "ellowRate": `${parseInt(data.ellowRate)} ${data.ellowCurrencyType} / ${data.ellowBillingType}`,
                "Supporting doc": data.supportingDocument,
                "Skills": data.skills && data.skills.map((item: any) => {return item.name}),
                "Sign In date": data.signInDate ? new Date(data.signInDate).toDateString() : 'NA',
                "Reporting manager name": data.reportingManagerName,
                "Reporting manager email": data.reportingManagerEmail,
                "Project name": data.projectName.projectName,
                'distinct_id': localStorage.getItem('Email'),
                "Candidate email": candidateEmail,
                'Closed by': response.data[0].contract_metadata.closedBy,
                "Candidate company email": data.candidateCompanyEmail !== "" ? data.candidateCompanyEmail : candidateEmail,
                "Position name": jobDetails && jobDetails.title,
                "Company name": jobDetails && jobDetails.postPosition.companyName
              })
              userProfile({
                'Availability': `Incontract` 
              }, contractLoginId)
              if(jobDetails && Math.floor(jobDetails.resourceCount)-(jobDetails.closedCount)-(jobDetails.lossCount) - (1) === 0){
                mixpanelData(`TestPositions Closed`, {
                  'Source': `Recruiter changed position to losed`,
                  'Position changed to': 'Closed',
                  'Company name': jobDetails && jobDetails.companyName,
                  'Position name': jobDetails  && jobDetails.title,
                  'distinct_id': localStorage.getItem('Email'),
                  'Recruiter email': localStorage.getItem('Email'),
                  'JobId': data.jobId,
                  'JobRole': jobDetails && jobDetails.jobRole && jobDetails.jobRole.name,
                  'Active position': jobDetails && (jobDetails.resourceCount)-(jobDetails.closedCount)-(jobDetails.lossCount),
                  'Experience range': jobDetails && jobDetails.experienceRange,
                  'Core skills': jobDetails && jobDetails.coreSkills && jobDetails.coreSkills.length > 0 && jobDetails.coreSkills.map((item: any) => item.skillName),
                  'Other skills': jobDetails && jobDetails.otherSkills && jobDetails.otherSkills.length > 0 && jobDetails.otherSkills.map((item: any) => item.skillName),
                  'Work location': jobDetails && jobDetails.locationPreference && checkWorkLocation(jobDetails.locationPreference.remoteType, jobDetails.locationPreference?.location),
                  // 'Work LocationArray': locations,
                  'Contract start date': jobDetails && jobDetails.contractStartDate && (new Date(jobDetails.contractStartDate)).toDateString(),
                  'Priority': jobDetails && jobDetails.priority && checkPriority(jobDetails.priority),
                  'Allocated to': props.positionData && props.positionData.allocatedToName,
                  'Job type': jobDetails && jobDetails.jobType,
                  'Crowdsourcing enabled': props.positionData && props.positionData.crowdsourcing_enabled
                })
              }
              setContractDetails(false)

              let value = {
                "candidateId": contractLoginId,
                "userLoginId": userLoginId,
                "jobId": jobId,
                "positionStatus": 5,
                "jobType": jobDetails.jobType
              }
              updatePositionStatusFunction(value)

            }
            props.getPositionDetails()

          })
        }
      })
    }
  }

  const submmitFUlltimeDetails = (data: any) => {
    data.contractId = uuidv4()
    let value = {
      "candidateId": contractLoginId,
      "userLoginId": userLoginId,
      "jobId": jobId,
      "submittedBy":  "RECRUITER",
      "fullTimeMetadata": data,
    }
    saveFulltimejobDetails(value).then((resp) => {
      if (resp && resp.status === 1) {
        setFulltimeDetails(false)
        let newvalue = {
          "candidateId": contractLoginId,
          "userLoginId": userLoginId,
          "jobId": jobId,
          "positionStatus": 5,
          "jobType": jobDetails.jobType
        }
        updatePositionStatusFunction(newvalue)
      }
      props.getPositionDetails()
    })
    
  }

  const positionStatusDropdown = (props: GridCellProps, getTableValues: any) => {

    const { dataItem } = props;
    const field = props.field || '';

    const dataValue = dataItem[field] === null ? '' : dataItem[field];

    const handleChange = (e: DropDownListChangeEvent) => {
      
      if (e.target.value.id === 5 && dataItem.paymentSettings) {
        // getProjectWithcustomerId()
        // setAllocatedTo(props.dataItem && props.dataItem.allocatedTo && props.dataItem.allocatedTo.map((item: any) => item.name))
        setContractLoginId(props.dataItem.loginId)
        if(jobDetails.jobType === 'Full time'){ 
          setCreatedBy(props.dataItem.createdBy)
          setFulltimeDetails(true)
        }else{
          setContractDetails(true)
          // setFulltimeDetails(true)
        }
        if (props.dataItem.positionStatus !== "Resource Accepted Offer") {
          setContractDefaultData('')
          setEllowRate(props.dataItem.positionEllowRate)
          setCurrencyType(props.dataItem.positionCurrencyType)
          setBillingType(props.dataItem.positionBillingType)
        }
        else {
          setContractDefaultData(props.dataItem.contractMetadata)
          setCandidateEmail(props.dataItem.candidateEmail)
          setEllowRate(props.dataItem.positionEllowRate)
          setCurrencyType(props.dataItem.positionCurrencyType)
          setBillingType(props.dataItem.positionBillingType)
        }
      }
      else if (e.target.value.id === 5 && !dataItem.paymentSettings) {
        setType('error')
        setIcon(true)
        displayNotification('Payment settings are not saved by the HR team,  Please reach out to them in order to complete this step')
      }

      else if (e.target.value.id !== 5) {
        let value = {
          "candidateId": props.dataItem.loginId,
          "userLoginId": userLoginId,
          "jobId": jobId,
          "positionStatus": e.target.value.id,
          "jobType": jobDetails.jobType
        }
        updatePositionStatusFunction(value)
      }
    }
    
    return (
      <td>
        {userLoginId === allocatedToId && dataValue !== 'Resource Accepted Offer' && dataItem && dataItem.inEdit ? (
          <DropDownList
            style={{ width: "100%" }}
            data={CONSTANTS.positionStatuswithId}
            onChange={handleChange}
            dataItemKey='id'
            textField="name"
          />
        ) : (dataValue)}
      </td>
    )
  }

  const displayNotification = (message: string) => {
    setMessage(message)
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
    }, 3000);
  }


  const getTableValues = () => {
    props.getTables()
  }
  //vishnu
  const openInNewTab = (url: any) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  const redirection = (candidateLoginId: string) => {
    localStorage.setItem('ResourcesCandidateLoginId', candidateLoginId);
    localStorage.setItem('ResourcesTab', '6');
    openInNewTab(`${window.location.origin}/createResources`)
    // navigate('../createResources', { state: { candidateLoginId: candidateLoginId, tab: 4 } })
  }

  const submitAddProject = (data: any) => {

    let body = {
      "action": "add",
      "projectId": data.projectId,
      "projectName": data.projectName,
      "customerId": customerId,
      "reportingManagerName": data.reportingManagerName,
      "reportingManagerEmail": data.reportingManagerEmail,
      "userLoginId": userLoginId

    }
    updateProject(body).then((response: any) => {
      if (response && response.status === 1) {


      }
    })
  }

  // const getProjectDetailsById = (projectId: any) => {
  //   getProjectDetails(projectId).then((response: any) => {
  //     if (response && response.status === '1') {        
  //       return response.data[0]
  //     }
  //   })
  // }


  return (
    <div className='tableStyle no-top-padd no-min-height tableMaxHeight'>
      <Grid
        data={orderBy(props.state.items, sort, '')}
        onPageChange={props.pageChange}
        //   total={props.total}
        //   skip={props.state.skip}
        //   pageable={props.state.pageable}
        //   pageSize={props.state.pageSize}
        //   onItemChange={props.itemChange}
        onRowClick={(e) => rowClick(e)}
        sortable={true}
        sort={sort}
        onSortChange={(e) => {
          setSort(e.sort);
        }}
      >
        <GridNoRecords>
          <div className="noData">
            <Icon icon="mdi:smiley-neutral-outline" />
            No data to display
          </div>
        </GridNoRecords>
        <Column field="name" title="Name" className="pointer" cell={(props: GridCellProps) => nameCell(props, (candidateLoginId: string) => redirection(candidateLoginId))} />
        <Column field="Skills" title="Skills" cell={skillsCell} />
        <Column field="experience" title="Experience" cell={experienceCell} />
        <Column field="ellowStatus" title="ellow Status" />
        <Column field="availabilityValue" title="Availability" cell={availablityCell} />
        <Column field="resourceCost" title="Resource Cost" cell={resourcecostCell} />
        <Column field="positionEllowRate" title="ellow Rate" cell={ellowrateCell} />
        <Column field="positionStatus" title="Position Status" cell={(props: GridCellProps) => positionStatusDropdown(props, () => getTableValues())} />
        {/* <Column field="signInDate" title="Sign In Date" cell={signInDateCell} /> */}
        <Column cell={viewButton} />
      </Grid>
      { fulltimeDetails && <FulltimeDetails onClose={() => setFulltimeDetails(false)} allocatedTo={allocatedTo} allRecruiters={allRecruiters} ClickHandler={submmitFUlltimeDetails} buttonName={'Save'} createdBy={createdBy}/>}
      { contractDetails && <ContractDetails onClose={() => setContractDetails(false)} allocatedTo={allocatedTo} ClickHandler={submitContractDetails} defaultvalues={contractDefaultData} projectData={projectData} jobMetadata={props.jobMetadata} contractEndDate={contractEndDate} buttonName={'Save'} projectList={projectList} submitAddProject={submitAddProject} terminateComment={terminateComment} getProjectDetailsById={getProjectDetails} duration={props.jobMetadata.contractDuration} skillsList={skillList} />}
      {notification && <NotificationAlert onClose={() => setNotification(false)} closable={true} type={type} icon={icon} >{message}</NotificationAlert>}
    </div>
  )
}

export default AppliedResourcesTable;

const nameCell = (props: GridCellProps, redirection: any) => {

  const profileImage = props.dataItem.googleProfileImage ? props.dataItem.googleProfileImage : " "

  return (
    <td>
      <div className="userInfo 001" onClick={() => redirection(props.dataItem.loginId)}>
        {profileImage === " " ?
          <figure>{props.dataItem && props.dataItem.firstName && props.dataItem.firstName[0]}{props.dataItem && props.dataItem.lastName && props.dataItem.lastName[0]}</figure>
          :
          <figure><img src={profileImage}></img></figure>}
        {props.dataItem.name}
      </div>
    </td>
  )
}
